export {embedded} from './lib/index.js'
